export default {
  routes: [
    // 生日push落地页
    // 日均uv为60
    {
      path: '/birthday/index',
      name: 'birthday',
      meta: {
        desc: '生日push落地页'
      },
      component: () => import(/* webpackChunkName: "birthday" */ '../views/birthday/index.vue')
    }
  ]
}
